import {ReRelationType} from '../../interfaces/relatives/re-relation-type';

export class ReRelationTypeFactory {
  /**
   *
   * @param reRelationType
   */
  public static fromObject(reRelationType: any): ReRelationType {
    return new class implements ReRelationType {
      created: string = reRelationType.created;
      id: number = reRelationType.id;
      isActive: boolean = reRelationType.is_active;
      modified: string = reRelationType.modified;
      name: string = reRelationType.name;
    };
  }

  /**
   *
   * @param reRelationTypes
   */
  public static fromArray(reRelationTypes: any[]): ReRelationType[] {
    return reRelationTypes.map(_reRelationType => this.fromObject(_reRelationType));
  }
}
